// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chat-widget." + {"46":"601678075d6f12ed14e4","916":"1ec40975c774a76f3be0"}[chunkId] + ".chunk.js";
};